(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.MarmotMotoveLogic = api;
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  function countdown(deadlineMs, nowMs) {
    var left = Math.max(0, Number(deadlineMs) - Number(nowMs));
    return {
      days: Math.floor(left / 86400000),
      hours: Math.floor(left / 3600000) % 24,
      minutes: Math.floor(left / 60000) % 60,
      expired: left <= 0
    };
  }

  function amountFromJson(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
    var keys = Object.keys(value);
    if (keys.length !== 1 || typeof value[keys[0]] !== 'number' || !Number.isFinite(value[keys[0]])) return null;
    return value[keys[0]];
  }

  function fetchAmount(url, threshold, fetchImpl, timeoutMs, timers) {
    if (!url || typeof fetchImpl !== 'function') return Promise.resolve(null);
    // Обвивки, не голите функции: извикан като метод на друг обект, setTimeout на браузъра
    // хвърля „Illegal invocation“ и сумата никога не се показва (кадър в копието на темата, 09.10).
    var clock = timers || {
      setTimeout: function (fn, ms) { return setTimeout(fn, ms); },
      clearTimeout: function (id) { return clearTimeout(id); }
    };
    var timeoutId;
    var timeout = new Promise(function (resolve) {
      timeoutId = clock.setTimeout(function () { resolve(null); }, Math.max(1, Number(timeoutMs) || 2500));
    });
    var request;
    try {
      request = Promise.resolve(fetchImpl(url, { credentials: 'omit', cache: 'no-store' }))
        .then(function (response) { return response && response.ok ? response.json() : null; })
        .then(amountFromJson)
        .then(function (amount) { return amount !== null && amount >= Number(threshold) ? amount : null; })
        .catch(function () { return null; });
    } catch (error) {
      request = Promise.resolve(null);
    }
    return Promise.race([request, timeout]).then(function (value) {
      if (timeoutId) clock.clearTimeout(timeoutId);
      return value;
    });
  }

  return {
    countdown: countdown,
    amountFromJson: amountFromJson,
    fetchAmount: fetchAmount
  };
});
